import axios from "axios";
import { HaywireUrlsInterface } from "../../shared/Interfaces/globalContextInterface";

export type ArcUser = {
	username: string;
	expiresAt: string;
	license: string;
	token: string;
};

export const verifyArcSession = async (
	requestToken: string,
	haywireUrls: HaywireUrlsInterface | null,
	deviceUuid: string,
): Promise<ArcUser | null> => {
	if (!requestToken) return null;

	try {
		const response = await axios.get(
			`${haywireUrls?.identity_base_url}${haywireUrls?.identity_api_version}/${haywireUrls?.identity_session}/${requestToken}`,
			{
				headers: {
					"X-Session": requestToken,
					"X-API-Key": haywireUrls?.identity_api_key || "",
					"X-Device-UUID": deviceUuid || haywireUrls?.device_uuid,
				},
			},
		);

		return {
			username: response?.data?.username,
			expiresAt: response?.data?.expiresAt,
			license: response?.data?.license,
			token: response?.data?.token,
		};
	} catch (e) {
		console.error("verifyArcSession -> error", e);
	}

	return null;
};
